<template>
  <div class="form-group mb-20">
    <div class="form-check custom-checkbox-wrapper" @click.prevent="toggle">
      <input
        type="checkbox"
        class="form-check-input d-none"
        :id="checkboxId"
        :checked="isChecked"
        @change="toggle"
      />
      <label :for="checkboxId" class="form-check-label">
        <img
          :src="isChecked ? checkedIcon : uncheckedIcon"
          class="custom-checkbox-icon"
          alt="checkbox"
        />
        <span class="custom-checkbox-label">
          <slot />
        </span>
      </label>
    </div>
    <small v-if="error" class="form-text text-error">{{ error }}</small>
    <small v-else-if="hint" class="form-text text-muted">{{ hint }}</small>
  </div>
</template>

<script>
import { computed, defineComponent } from "vue";
import checkedIcon from "@/assets/svg/checkbox-checked.svg";
import uncheckedIcon from "@/assets/svg/checkbox-unchecked.svg";

export default defineComponent({
  name: "AppCheckbox",
  props: {
    modelValue: {
      type: [Boolean, Array],
      required: true,
    },
    value: {
      type: [String, Number, Boolean, Object],
      default: true,
    },
    hint: String,
    error: String,
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const checkboxId = computed(
      () => `checkbox-${Math.random().toString(36).substr(2, 9)}`
    );

    const isArray = computed(() => Array.isArray(props.modelValue));

    const isChecked = computed(() => {
      if (isArray.value) {
        return props.modelValue.includes(props.value);
      }
      return props.modelValue;
    });

    const toggle = () => {
      if (isArray.value) {
        const newValue = [...props.modelValue];
        const index = newValue.indexOf(props.value);

        if (index > -1) {
          newValue.splice(index, 1);
        } else {
          newValue.push(props.value);
        }

        emit("update:modelValue", newValue);
      } else {
        emit("update:modelValue", !props.modelValue);
      }
    };

    return {
      checkboxId,
      isChecked,
      checkedIcon,
      uncheckedIcon,
      toggle,
    };
  },
});
</script>

<style scoped lang="less">
@import "@/styles/_variables.less";
@import "@/styles/_input-styles.less";

.custom-checkbox-wrapper {
  display: flex;
  align-items: center;
  cursor: pointer;

  .form-check-label {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .custom-checkbox-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  .custom-checkbox-label {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.005em;
    color: @white;
    transition: color 0.2s ease;
  }
}
</style>
